"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.stringsToPhones = exports.clipboardTagsToPhone = exports.clipboardPhoneSelf = exports.clipboardJsonToPhone = exports.clipboardTextToPhone = exports.clipboardTextToDateRange = exports.clipboardTextToDueDate = exports.clipboardCreatedUpdatedToDueDate = exports.clipboardDateRangeToDueDate = exports.clipboardDueDateToSelf = exports.clipboardDependencyToSelf = exports.clipboardDateToDueDate = exports.clipboardEmailSelf = exports.clipboardJsonToEmail = exports.clipboardTextToEmail = exports.clipboardCreatedUpdatedToFullName = exports.clipboardUserToFullName = exports.clipboardFullNameSelf = exports.clipboardTextToFullName = exports.clipboardTagsToStatusField = exports.clipboardMultipleSelectToStatusField = exports.clipboardSingleSelectToStatusField = exports.clipboardReferenceFieldToStatusField = exports.clipboardTextToStatusField = exports.clipboardStatusFieldToSelf = exports.clipboardTextToDate = exports.clipboardCreatedUpdatedToDate = exports.clipboardDueDateToDate = exports.clipboardDateRangeToDate = exports.clipboardFullNameToMultiple = exports.clipboardStatusToMultiSelect = exports.clipboardEmailToMultiSelect = exports.clipboardTeamToMultipleSelect = exports.clipboardMemberToMultipleSelect = exports.clipboardSingleSelectToMultipleSelect = exports.clipboardTagToMultipleSelect = exports.clipboardMultipleSelectToSelf = exports.clipboardReferenceFieldToMultipleSelectField = exports.clipboardCreatedUpdatedToMultiple = exports.clipboardTextToChoices = exports.clipboardFullNameToSingle = exports.clipboardStatusSingleSelect = exports.clipboardEmailSingleSelect = exports.clipboardTeamToSingleSelect = exports.clipboardMemberToSingleSelect = exports.clipboardMultipleSelectToSingle = exports.clipboardTextToChoice = exports.clipboardSingleSelectSelf = exports.clipboardReferenceFieldToSingleSelectField = exports.clipboardCreatedUpdatedToSingleSelect = void 0;
exports.clipboardTextToIpAddress = exports.clipboardIpAddressSelf = exports.clipboardReferenceFieldToIP = exports.clipboardColorPickerToTag = exports.clipboardIPToTag = exports.clipboardPhoneToTag = exports.clipboardMembersToTag = exports.clipboardReferenceToTag = exports.clipboardListFieldsToTag = exports.clipboardTagToSelf = exports.clipboardRecordIdToTag = exports.clipboardTextToTag = exports.clipboardAnyToTag = exports.clipboardTextToChecklist = exports.textToChecklistValue = exports.parseFullColorValue = exports.clipboardTextToColor = exports.clipboardSocialToSocial = exports.clipboardTextToSocial = exports.clipboardTimeTrackingToSelf = exports.clipboardDueDateToDateRange = exports.clipboardCreatedUpdatedToDateRange = exports.clipboardDateRangeToDateRange = exports.clipboardDateToDateRange = exports.clipboardTextToDuration = exports.clipboardTextToTime = exports.clipboardTimeToSelf = exports.clipboardLinkedRecordToMember = exports.clipboardTextToMember = exports.clipboardFullNameToMember = exports.clipboardMemberToSelf = exports.clipboardCreatedUpdatedToMember = exports.clipboardForTextToLinkedRecordField = exports.clipboardLinkedRecordFieldToSelf = exports.selfToDoc = exports.rawToDoc = exports.docPasteRules = exports.clipboardReferenceFieldToLink = exports.clipboardTextToLink = exports.clipboardLinkSelf = exports.clipboardTextToAddress = void 0;
const libphonenumber_js_1 = require("libphonenumber-js");
const get_value_1 = require("../safe-field-value/reference-fields/dependency-field/get-value");
const date_range_1 = require("../utils/date-range");
const types_1 = require("@smartsuite/types");
const utils_1 = require("./utils");
const date_1 = require("../utils/date");
const fields_logic_registry_1 = require("../field-type-registry/fields-logic-registry");
const fields_1 = require("../utils/fields");
const email_validation_1 = require("@smartsuite/email-validation");
const isEqual_1 = __importDefault(require("lodash-es/isEqual"));
const phone_1 = require("../utils/phone");
const clipboard_1 = require("../utils/clipboard");
const member_1 = require("../utils/member");
const assigned_to_1 = require("../filter/assigned-to");
const moment_1 = __importDefault(require("moment"));
const duration_1 = require("../utils/duration");
const get_value_2 = require("../safe-field-value/date-fields/time-tracking-field/get-value");
const social_network_1 = require("../utils/social-network");
const comparisons_1 = require("../comparisons/comparisons");
const parsers_1 = require("@smartsuite/smartdoc/lib/esm/helpers/parsers");
const uuid_1 = require("uuid");
const record_1 = require("../utils/record");
const linked_record_1 = require("../utils/linked-record");
const status_1 = require("../utils/status");
const link_1 = require("../utils/link");
function clipboardCreatedUpdatedToSingleSelect(clipboardValue, srcField, targetField, userPreferences, currentValue) {
    const choice = (0, utils_1.clipboardCreatedUpdatedToChoice)(clipboardValue, targetField);
    if (choice) {
        return choice.value;
    }
    const serializedClipboardValue = (0, utils_1.serializeClipboardCreatedUpdated)(clipboardValue);
    return serializedClipboardValue !== null && serializedClipboardValue !== void 0 ? serializedClipboardValue : currentValue;
}
exports.clipboardCreatedUpdatedToSingleSelect = clipboardCreatedUpdatedToSingleSelect;
function clipboardReferenceFieldToSingleSelectField(clipboardValue, srcField, targetField, userPreferences, currentValue) {
    var _a;
    if (!(clipboardValue === null || clipboardValue === void 0 ? void 0 : clipboardValue.text)) {
        return currentValue;
    }
    const labels = (0, utils_1.processClipboardTextValueWithSeparators)(clipboardValue);
    const choices = (_a = targetField.params.choices) !== null && _a !== void 0 ? _a : [];
    const values = labels.map((pastedLabel) => {
        var _a, _b;
        return (_b = (_a = choices.find(({ label }) => label.trim().toLowerCase() === pastedLabel.trim().toLowerCase())) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : pastedLabel;
    });
    return values.length ? values[0] : currentValue;
}
exports.clipboardReferenceFieldToSingleSelectField = clipboardReferenceFieldToSingleSelectField;
function clipboardSingleSelectSelf(clipboardValue, srcField, targetField, userPreferences, currentValue) {
    var _a, _b, _c;
    const { text, rawValue } = clipboardValue;
    // paste to the same SingleSelectField
    const foundedChoiceByValue = (_a = targetField.params.choices) === null || _a === void 0 ? void 0 : _a.find((choice) => choice.value === rawValue);
    if (foundedChoiceByValue) {
        return rawValue !== null && rawValue !== void 0 ? rawValue : "";
    }
    // paste to another SingleSelectField
    const foundChoiceByLabel = (_b = targetField.params.choices) === null || _b === void 0 ? void 0 : _b.find((choice) => choice.label.trim().toLowerCase() === text.trim().toLowerCase());
    if (foundChoiceByLabel) {
        return foundChoiceByLabel.value;
    }
    return (_c = text.trim()) !== null && _c !== void 0 ? _c : currentValue;
}
exports.clipboardSingleSelectSelf = clipboardSingleSelectSelf;
function clipboardTextToChoice(clipboardValue, srcField, targetField, userPreferences, currentValue) {
    var _a;
    const newValueIsEmpty = !clipboardValue.text.replace(/\n/g, " ").trim();
    if (newValueIsEmpty && !targetField.params.required) {
        return "";
    }
    const clipboardValueText = withChoiceMaxLength(targetField, clipboardValue.text.trim());
    const choice = (_a = targetField.params.choices) === null || _a === void 0 ? void 0 : _a.find(({ label }) => label.trim().toLowerCase() === clipboardValue.text.trim().toLowerCase());
    return choice ? choice.value : clipboardValueText;
}
exports.clipboardTextToChoice = clipboardTextToChoice;
function clipboardMultipleSelectToSingle(clipboardValue, srcField, targetField, userPreferences, currentValue) {
    var _a, _b, _c, _d;
    if (!clipboardValue.rawValue) {
        return currentValue;
    }
    const srcChoices = (_b = (_a = srcField.params) === null || _a === void 0 ? void 0 : _a.choices) !== null && _b !== void 0 ? _b : [];
    const targetChoices = (_c = targetField.params.choices) !== null && _c !== void 0 ? _c : [];
    const clipboardValueLabels = clipboardValue.rawValue.map((value) => { var _a; return (_a = srcChoices.find((choice) => choice.value === value)) === null || _a === void 0 ? void 0 : _a.label.toLowerCase(); });
    const choice = (0, utils_1.getChoicesIntersection)(targetChoices, srcChoices).find((choice) => clipboardValueLabels.includes(choice.label.toLowerCase()));
    return (_d = choice === null || choice === void 0 ? void 0 : choice.value) !== null && _d !== void 0 ? _d : clipboardValue.text;
}
exports.clipboardMultipleSelectToSingle = clipboardMultipleSelectToSingle;
function clipboardMemberToSingleSelect(clipboardValue, srcField, targetField, userPreferences, currentValue) {
    const memberToStrFn = (member) => { var _a, _b; return `${(_a = member.full_name.first_name) === null || _a === void 0 ? void 0 : _a.toLowerCase()} ${(_b = member.full_name.last_name) === null || _b === void 0 ? void 0 : _b.toLowerCase()}`; };
    return referenceToSingleSelectHelper(clipboardValue, srcField, targetField, currentValue, memberToStrFn);
}
exports.clipboardMemberToSingleSelect = clipboardMemberToSingleSelect;
function clipboardTeamToSingleSelect(clipboardValue, srcField, targetField, userPreferences, currentValue) {
    const teamToStrFn = (team) => team.name.toLowerCase();
    return referenceToSingleSelectHelper(clipboardValue, srcField, targetField, currentValue, teamToStrFn);
}
exports.clipboardTeamToSingleSelect = clipboardTeamToSingleSelect;
function clipboardEmailSingleSelect(clipboardValue, srcField, targetField, userPreferences, currentValue) {
    var _a, _b, _c, _d;
    const email = ((_a = clipboardValue.rawValue) === null || _a === void 0 ? void 0 : _a.length)
        ? clipboardValue.rawValue[0]
        : null;
    const foundChoice = email
        ? (_b = targetField.params.choices) === null || _b === void 0 ? void 0 : _b.find((choice) => choice.label === email)
        : null;
    return (_d = (_c = foundChoice === null || foundChoice === void 0 ? void 0 : foundChoice.value) !== null && _c !== void 0 ? _c : email) !== null && _d !== void 0 ? _d : currentValue;
}
exports.clipboardEmailSingleSelect = clipboardEmailSingleSelect;
function clipboardStatusSingleSelect(clipboardValue, srcField, targetField, userPreferences, currentValue) {
    var _a, _b, _c;
    const status = clipboardValue.text;
    const foundChoice = status
        ? (_a = targetField.params.choices) === null || _a === void 0 ? void 0 : _a.find((choice) => choice.label === status)
        : null;
    return (_c = (_b = foundChoice === null || foundChoice === void 0 ? void 0 : foundChoice.value) !== null && _b !== void 0 ? _b : status) !== null && _c !== void 0 ? _c : currentValue;
}
exports.clipboardStatusSingleSelect = clipboardStatusSingleSelect;
function clipboardFullNameToSingle(clipboardValue, srcField, targetField, userPreferences, currentValue) {
    var _a;
    const foundChoiceValue = (0, utils_1.findChoiceValueByText)(targetField, clipboardValue.text);
    return (_a = foundChoiceValue !== null && foundChoiceValue !== void 0 ? foundChoiceValue : clipboardValue === null || clipboardValue === void 0 ? void 0 : clipboardValue.text.trim()) !== null && _a !== void 0 ? _a : currentValue;
}
exports.clipboardFullNameToSingle = clipboardFullNameToSingle;
function referenceToSingleSelectHelper(clipboardValue, srcField, targetField, currentValue, toStringFn) {
    var _a, _b, _c, _d;
    const refStrings = (_b = (_a = clipboardValue.rawValue) === null || _a === void 0 ? void 0 : _a.map(toStringFn)) !== null && _b !== void 0 ? _b : [];
    const foundChoice = (_c = targetField.params.choices) === null || _c === void 0 ? void 0 : _c.find((choice) => refStrings.includes(choice.label.toLowerCase()));
    if (foundChoice) {
        return String(foundChoice === null || foundChoice === void 0 ? void 0 : foundChoice.value);
    }
    return (_d = refStrings === null || refStrings === void 0 ? void 0 : refStrings[0]) !== null && _d !== void 0 ? _d : currentValue;
}
function clipboardTextToChoices(clipboardValue, srcField, targetField, userPreferences, currentValue) {
    const newValueIsEmpty = !clipboardValue.text.replace(/\n/g, " ").trim();
    if (newValueIsEmpty && !targetField.params.required) {
        return [];
    }
    const clipboardLabels = clipboardValue.text
        .split(/[,;|]/)
        .map((label) => label.trim())
        .filter((label) => !!label && !!label.length);
    const foundChoices = clipboardLabels.map((label) => {
        var _a, _b, _c;
        return (_c = (_b = (_a = targetField.params.choices) === null || _a === void 0 ? void 0 : _a.find((choice) => choice.label.trim().toLowerCase() === label.toLowerCase())) === null || _b === void 0 ? void 0 : _b.value) !== null && _c !== void 0 ? _c : label;
    });
    if (!foundChoices.length) {
        return currentValue;
    }
    return foundChoices;
}
exports.clipboardTextToChoices = clipboardTextToChoices;
function clipboardCreatedUpdatedToMultiple(clipboardValue, srcField, targetField, userPreferences, currentValue) {
    const choice = (0, utils_1.clipboardCreatedUpdatedToChoice)(clipboardValue, targetField);
    if (choice) {
        return [choice.value];
    }
    const serializedClipboardValue = (0, utils_1.serializeClipboardCreatedUpdated)(clipboardValue);
    return serializedClipboardValue ? [serializedClipboardValue] : currentValue;
}
exports.clipboardCreatedUpdatedToMultiple = clipboardCreatedUpdatedToMultiple;
function clipboardReferenceFieldToMultipleSelectField(clipboardValue, srcField, targetField, _userPreferences, currentValue) {
    var _a;
    if (!(clipboardValue === null || clipboardValue === void 0 ? void 0 : clipboardValue.text)) {
        return currentValue;
    }
    const labels = (0, utils_1.processClipboardTextValueWithSeparators)(clipboardValue);
    const choices = (_a = targetField.params.choices) !== null && _a !== void 0 ? _a : [];
    const values = labels.map((pastedLabel) => {
        var _a, _b;
        return (_b = (_a = choices.find(({ label }) => label.trim().toLowerCase() === pastedLabel.trim().toLowerCase())) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : pastedLabel;
    });
    return values.length ? values : currentValue;
}
exports.clipboardReferenceFieldToMultipleSelectField = clipboardReferenceFieldToMultipleSelectField;
function clipboardMultipleSelectToSelf(clipboardValue, srcField, targetField, userPreferences, currentValue) {
    var _a, _b, _c, _d, _e;
    if (((_a = clipboardValue === null || clipboardValue === void 0 ? void 0 : clipboardValue.rawValue) === null || _a === void 0 ? void 0 : _a.length) === 0) {
        return currentValue;
    }
    const clipboardValueLabels = ((_b = clipboardValue === null || clipboardValue === void 0 ? void 0 : clipboardValue.rawValue) !== null && _b !== void 0 ? _b : []).map((value) => {
        var _a, _b, _c;
        return (_c = (_b = (_a = srcField.params) === null || _a === void 0 ? void 0 : _a.choices) === null || _b === void 0 ? void 0 : _b.find((choice) => String(choice.value) === value)) === null || _c === void 0 ? void 0 : _c.label.toLowerCase();
    });
    const choicesFrom = (_d = (_c = srcField.params) === null || _c === void 0 ? void 0 : _c.choices) !== null && _d !== void 0 ? _d : [];
    const choicesTo = (_e = targetField.params.choices) !== null && _e !== void 0 ? _e : [];
    const result = [
        ...(0, utils_1.getChoicesIntersection)(choicesTo, choicesFrom)
            .filter((choice) => clipboardValueLabels.includes(choice.label.toLowerCase()))
            .map((choice) => choice.value),
        ...(0, utils_1.getChoicesToAdd)(choicesFrom, choicesTo)
            .filter((choice) => clipboardValueLabels.includes(choice.label.toLowerCase()))
            .map((choice) => choice.label),
        // we need this case for frontend migration. If we migrate multiselect field by adding
        // choices, we have to be ready the value of a new choice is already in the record and we
        // have to support it
        ...(srcField.slug === targetField.slug
            ? (0, utils_1.getChoicesToAdd)(choicesTo, choicesFrom)
                .filter((choice) => !clipboardValueLabels.includes(choice.label.toLowerCase()))
                .map((choice) => choice.value)
            : []),
    ];
    return result.length ? result : currentValue;
}
exports.clipboardMultipleSelectToSelf = clipboardMultipleSelectToSelf;
function clipboardTagToMultipleSelect(clipboardValue, srcField, targetField, userPreferences, currentValue) {
    var _a, _b, _c, _d, _e;
    if (((_a = clipboardValue === null || clipboardValue === void 0 ? void 0 : clipboardValue.rawValue) === null || _a === void 0 ? void 0 : _a.length) === 0) {
        return currentValue;
    }
    const clipboardValueLabels = ((_b = clipboardValue === null || clipboardValue === void 0 ? void 0 : clipboardValue.rawValue) !== null && _b !== void 0 ? _b : []).map((value) => {
        var _a, _b, _c;
        return (_c = (_b = (_a = srcField.params) === null || _a === void 0 ? void 0 : _a.choices) === null || _b === void 0 ? void 0 : _b.find((choice) => String(choice.value) === value)) === null || _c === void 0 ? void 0 : _c.label.toLowerCase();
    });
    const choicesFrom = (_d = (_c = srcField.params) === null || _c === void 0 ? void 0 : _c.choices) !== null && _d !== void 0 ? _d : [];
    const choicesTo = (_e = targetField.params.choices) !== null && _e !== void 0 ? _e : [];
    const result = [
        ...(0, utils_1.getChoicesIntersection)(choicesTo, choicesFrom)
            .filter((choice) => clipboardValueLabels.includes(choice.label.toLowerCase()))
            .map((choice) => choice.value),
        ...(0, utils_1.getChoicesToAdd)(choicesFrom, choicesTo)
            .filter((choice) => clipboardValueLabels.includes(choice.label.toLowerCase()))
            .map((choice) => choice.label),
    ];
    return result.length ? result : currentValue;
}
exports.clipboardTagToMultipleSelect = clipboardTagToMultipleSelect;
function clipboardSingleSelectToMultipleSelect(clipboardValue, srcField, targetField, userPreferences, currentValue) {
    var _a, _b, _c, _d;
    const choicesFrom = (_b = (_a = srcField.params) === null || _a === void 0 ? void 0 : _a.choices) !== null && _b !== void 0 ? _b : [];
    const choicesTo = (_c = targetField.params.choices) !== null && _c !== void 0 ? _c : [];
    const result = [
        ...(0, utils_1.getChoicesIntersection)(choicesTo, choicesFrom)
            .filter((choice) => {
            var _a, _b;
            return ((_a = clipboardValue === null || clipboardValue === void 0 ? void 0 : clipboardValue.rawValue) === null || _a === void 0 ? void 0 : _a.toLowerCase()) ===
                choice.label.toLowerCase() ||
                ((_b = clipboardValue === null || clipboardValue === void 0 ? void 0 : clipboardValue.text) === null || _b === void 0 ? void 0 : _b.toLowerCase()) === choice.label.toLowerCase();
        })
            .map((choice) => choice.value),
        ...(0, utils_1.getChoicesToAdd)(choicesFrom, choicesTo)
            .filter((choice) => { var _a; return ((_a = clipboardValue === null || clipboardValue === void 0 ? void 0 : clipboardValue.text) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === choice.label.toLowerCase(); })
            .map((choice) => choice.label),
    ];
    if (result.length) {
        return result;
    }
    if (clipboardValue === null || clipboardValue === void 0 ? void 0 : clipboardValue.text) {
        return [(_d = clipboardValue === null || clipboardValue === void 0 ? void 0 : clipboardValue.text) === null || _d === void 0 ? void 0 : _d.trim()];
    }
    return currentValue;
}
exports.clipboardSingleSelectToMultipleSelect = clipboardSingleSelectToMultipleSelect;
function clipboardMemberToMultipleSelect(clipboardValue, srcField, targetField, userPreferences, currentValue) {
    var _a, _b;
    const memberNames = (_b = (_a = clipboardValue.rawValue) === null || _a === void 0 ? void 0 : _a.map((member) => `${member.full_name.first_name} ${member.full_name.last_name}`.toLowerCase())) !== null && _b !== void 0 ? _b : [];
    const memberNameChoices = memberNames.map((memberName) => {
        var _a, _b, _c;
        return (_c = (_b = (_a = targetField.params.choices) === null || _a === void 0 ? void 0 : _a.find((choice) => memberNames === null || memberNames === void 0 ? void 0 : memberNames.includes(choice.label.toLowerCase()))) === null || _b === void 0 ? void 0 : _b.value) !== null && _c !== void 0 ? _c : memberName;
    });
    return memberNameChoices.length ? memberNameChoices : currentValue;
}
exports.clipboardMemberToMultipleSelect = clipboardMemberToMultipleSelect;
function clipboardTeamToMultipleSelect(clipboardValue, srcField, targetField, userPreferences, currentValue) {
    var _a, _b;
    const teamsNames = (_a = clipboardValue.rawValue) === null || _a === void 0 ? void 0 : _a.map((team) => team.name);
    const foundChoices = (_b = targetField.params.choices) === null || _b === void 0 ? void 0 : _b.filter((choice) => teamsNames === null || teamsNames === void 0 ? void 0 : teamsNames.includes(choice.label)).map((choice) => choice.value);
    return foundChoices.length ? foundChoices : currentValue;
}
exports.clipboardTeamToMultipleSelect = clipboardTeamToMultipleSelect;
function clipboardEmailToMultiSelect(clipboardValue, srcField, targetField, userPreferences, currentValue) {
    var _a;
    const emails = (_a = clipboardValue.rawValue) !== null && _a !== void 0 ? _a : [];
    const emailsChoices = emails.map((email) => {
        var _a, _b, _c;
        return (_c = (_b = (_a = targetField.params.choices) === null || _a === void 0 ? void 0 : _a.find((choice) => email === null || email === void 0 ? void 0 : email.includes(choice.label.toLowerCase()))) === null || _b === void 0 ? void 0 : _b.value) !== null && _c !== void 0 ? _c : email;
    });
    return emailsChoices.length ? emailsChoices : currentValue;
}
exports.clipboardEmailToMultiSelect = clipboardEmailToMultiSelect;
function clipboardStatusToMultiSelect(clipboardValue, srcField, targetField, userPreferences, currentValue) {
    var _a;
    const status = clipboardValue.text;
    const foundChoice = status
        ? (_a = targetField.params.choices) === null || _a === void 0 ? void 0 : _a.find((choice) => choice.label === status)
        : null;
    if (foundChoice === null || foundChoice === void 0 ? void 0 : foundChoice.value) {
        return [foundChoice.value];
    }
    if (status) {
        return [status];
    }
    return currentValue;
}
exports.clipboardStatusToMultiSelect = clipboardStatusToMultiSelect;
function clipboardFullNameToMultiple(clipboardValue, srcField, targetField, userPreferences, currentValue) {
    var _a, _b, _c;
    const foundChoiceValue = (_c = (_b = (_a = targetField.params.choices) === null || _a === void 0 ? void 0 : _a.find(({ label }) => label.trim().toLowerCase() === clipboardValue.text.trim().toLowerCase())) === null || _b === void 0 ? void 0 : _b.value) !== null && _c !== void 0 ? _c : clipboardValue.text.trim();
    if (foundChoiceValue) {
        return [foundChoiceValue];
    }
    return currentValue;
}
exports.clipboardFullNameToMultiple = clipboardFullNameToMultiple;
function clipboardDateRangeToDate(clipboardValue, ..._rest) {
    var _a;
    return (_a = clipboardValue.rawValue) === null || _a === void 0 ? void 0 : _a.from_date;
}
exports.clipboardDateRangeToDate = clipboardDateRangeToDate;
function clipboardDueDateToDate(clipboardValue, ..._rest) {
    var _a;
    return (_a = clipboardValue.rawValue) === null || _a === void 0 ? void 0 : _a.to_date;
}
exports.clipboardDueDateToDate = clipboardDueDateToDate;
function clipboardCreatedUpdatedToDate(clipboardValue, ..._rest) {
    return clipboardValue.rawValue.date;
}
exports.clipboardCreatedUpdatedToDate = clipboardCreatedUpdatedToDate;
function clipboardTextToDate(clipboardValue, _srcField, targetField, userPreferences, currentValue) {
    const newValueIsEmpty = !clipboardValue.text.replace(/\n/g, " ").trim();
    if (newValueIsEmpty) {
        if (targetField.params.required) {
            return currentValue;
        }
        return (0, date_1.emptyDateValue)();
    }
    const date = (0, date_1.textToDateValue)(clipboardValue.text, userPreferences);
    const fieldLogic = (0, fields_logic_registry_1.getFieldLogic)(targetField.field_type);
    if (!fieldLogic.isValueEmpty(date, targetField)) {
        return date;
    }
    else {
        return currentValue;
    }
}
exports.clipboardTextToDate = clipboardTextToDate;
function clipboardStatusFieldToSelf(clipboardValue, srcField, targetField, userPreferences, currentValue) {
    const rawValue = clipboardValue.rawValue;
    const srcLabel = (0, fields_1.getFieldChoiceLabel)(srcField, rawValue.value);
    return getClipboardValue(srcLabel, targetField, currentValue);
}
exports.clipboardStatusFieldToSelf = clipboardStatusFieldToSelf;
function clipboardTextToStatusField(clipboardValue, srcField, targetField, _userPreferences, currentValue) {
    const newValueIsEmpty = !clipboardValue.text.replace(/\n/g, " ").trim();
    if (newValueIsEmpty && !targetField.params.required) {
        return { value: "", updated_on: null };
    }
    const values = (0, utils_1.processClipboardTextValueWithSeparators)(clipboardValue);
    const label = getLabelFromArray(targetField, values);
    const value = getValueByLabel(targetField, label);
    if (!value) {
        return currentValue;
    }
    return {
        value,
        updated_on: null,
    };
}
exports.clipboardTextToStatusField = clipboardTextToStatusField;
function clipboardReferenceFieldToStatusField(clipboardValue, srcField, targetField, userPreferences, currentValue) {
    const values = (0, utils_1.processClipboardTextValueWithSeparators)(clipboardValue);
    if (values.length === 0) {
        return currentValue;
    }
    const label = getLabelFromArray(targetField, values);
    return getClipboardValue(label, targetField, currentValue);
}
exports.clipboardReferenceFieldToStatusField = clipboardReferenceFieldToStatusField;
function clipboardSingleSelectToStatusField(clipboardValue, srcField, targetField, userPreferences, currentValue) {
    const rawValue = clipboardValue.rawValue;
    const srcLabel = (0, fields_1.getFieldChoiceLabel)(srcField, rawValue);
    return getClipboardValue(srcLabel, targetField, currentValue);
}
exports.clipboardSingleSelectToStatusField = clipboardSingleSelectToStatusField;
function clipboardMultipleSelectToStatusField(clipboardValue, srcField, targetField, userPreferences, currentValue) {
    var _a;
    const rawValue = (_a = clipboardValue.rawValue) !== null && _a !== void 0 ? _a : [];
    const labels = getLabelsForValues(srcField, rawValue);
    const label = getLabelFromArray(targetField, labels);
    return getClipboardValue(label, targetField, currentValue);
}
exports.clipboardMultipleSelectToStatusField = clipboardMultipleSelectToStatusField;
function clipboardTagsToStatusField(clipboardValue, srcField, targetField, userPreferences, currentValue) {
    var _a;
    const rawValue = (_a = clipboardValue.rawValue) !== null && _a !== void 0 ? _a : [];
    const labels = getLabelsForValues(srcField, rawValue);
    const label = getLabelFromArray(targetField, labels);
    return getClipboardValue(label, targetField, currentValue);
}
exports.clipboardTagsToStatusField = clipboardTagsToStatusField;
function getClipboardValue(choiceLabel, targetField, currentValue) {
    const value = getValueByLabel(targetField, choiceLabel);
    if (!value) {
        // Filled status field cannot be cleared
        return currentValue;
    }
    return {
        value,
        updated_on: null,
    };
}
function getValueByLabel(field, label) {
    var _a, _b, _c;
    return ((_c = (_b = (_a = field.params.choices) === null || _a === void 0 ? void 0 : _a.find((choice) => choice.label.trim().toLowerCase() === (label === null || label === void 0 ? void 0 : label.toLowerCase()))) === null || _b === void 0 ? void 0 : _b.value) !== null && _c !== void 0 ? _c : "");
}
function getLabelFromArray(field, values) {
    var _a, _b, _c;
    const labels = (_b = (_a = field.params.choices) === null || _a === void 0 ? void 0 : _a.map((choice) => choice.label.trim().toLowerCase())) !== null && _b !== void 0 ? _b : [];
    return (_c = values.find((value) => labels.includes(value.toLowerCase()))) !== null && _c !== void 0 ? _c : "";
}
function getLabelsForValues(field, values) {
    return values.map((value) => (0, fields_1.getFieldChoiceLabel)(field, value));
}
/**
 * This function is only for local usage.
 */
function memberIsActive(member) {
    return (0, status_1.getMemberOrTeamStatus)(member).value === types_1.MemberStatuses.active;
}
function prepareValueToPaste(value, targetField, titleLabel = "") {
    if (!value) {
        return types_1.emptyFullNameFieldValue;
    }
    const title = titleLabel
        ? (0, fields_1.getFieldChoiceValueByLabel)(targetField, titleLabel)
        : "";
    return {
        ...value,
        title,
    };
}
function clipboardTextToFullName(clipboardValue, srcField, targetField, _userPreferences, currentValue) {
    var _a, _b, _c, _d;
    const newValueIsEmpty = !clipboardValue.text.replace(/\n/g, " ").trim();
    if (newValueIsEmpty && !targetField.params.required) {
        return { first_name: "", last_name: "" };
    }
    let title = "";
    const fullName = parseFirstAndLastName(clipboardValue.text, (_b = (_a = targetField.params.display_fields) === null || _a === void 0 ? void 0 : _a.includes("title")) !== null && _b !== void 0 ? _b : false);
    if (!fullName.first_name && !fullName.last_name) {
        return currentValue;
    }
    const fullNameData = clipboardValue.text.split(" ");
    if ((_c = targetField.params.display_fields) === null || _c === void 0 ? void 0 : _c.includes("title")) {
        title = fullNameData.length >= 4 ? fullNameData[0] : "";
    }
    if ((_d = targetField.params.display_fields) === null || _d === void 0 ? void 0 : _d.includes("middle_name")) {
        fullName.middle_name = clipboardValue.text
            .replace(title, "")
            .replace(fullName.first_name, "")
            .replace(fullName.last_name, "");
    }
    return prepareValueToPaste(fullName, targetField, title);
}
exports.clipboardTextToFullName = clipboardTextToFullName;
function parseFirstAndLastName(fullName, hasTitle) {
    if (!fullName) {
        return { first_name: "", last_name: "" };
    }
    if (fullName.includes(",")) {
        const parsedName = fullName.split(",");
        return {
            first_name: parsedName[1],
            last_name: parsedName[0],
        };
    }
    const splitName = fullName.split(" ");
    const firstName = hasTitle && splitName.length >= 4 ? splitName[1] : splitName[0];
    const lastName = splitName[splitName.length - 1];
    return { first_name: firstName, last_name: lastName };
}
function clipboardFullNameSelf(clipboardValue, srcField, targetField, _userPreferences) {
    var _a;
    const value = (_a = clipboardValue.rawValue) !== null && _a !== void 0 ? _a : null;
    const titleChoice = (0, fields_1.getFieldChoiceByValue)(srcField, value === null || value === void 0 ? void 0 : value.title);
    return prepareValueToPaste(value, targetField, titleChoice === null || titleChoice === void 0 ? void 0 : titleChoice.label);
}
exports.clipboardFullNameSelf = clipboardFullNameSelf;
function clipboardUserToFullName(clipboardValue, srcField, targetField, _userPreferences) {
    var _a, _b;
    const activeMembers = (_b = (_a = clipboardValue.rawValue) === null || _a === void 0 ? void 0 : _a.filter(memberIsActive)) !== null && _b !== void 0 ? _b : [];
    const fullName = activeMembers.length ? activeMembers[0].full_name : null;
    return prepareValueToPaste(fullName, targetField);
}
exports.clipboardUserToFullName = clipboardUserToFullName;
function clipboardCreatedUpdatedToFullName(clipboardValue, srcField, targetField, _userPreferences) {
    var _a, _b;
    const fullName = (_b = (_a = clipboardValue.rawValue) === null || _a === void 0 ? void 0 : _a.full_name) !== null && _b !== void 0 ? _b : null;
    return prepareValueToPaste(fullName, targetField);
}
exports.clipboardCreatedUpdatedToFullName = clipboardCreatedUpdatedToFullName;
function clipboardTextToEmail(clipboardValue, _srcField, targetField, _userPreferences, _currentValue) {
    const newValueIsEmpty = !clipboardValue.text.replace(/\n/g, " ").trim();
    if (newValueIsEmpty && !targetField.params.required) {
        return [];
    }
    const emails = (0, utils_1.processClipboardEmailTextValueWithSeparators)(clipboardValue).filter((value) => {
        return (0, email_validation_1.validateEmailAddress)(value.trim());
    });
    if (!emails.length) {
        return _currentValue;
    }
    return targetField.params.entries_allowed === "multiple"
        ? emails
        : [emails[0]];
}
exports.clipboardTextToEmail = clipboardTextToEmail;
function clipboardJsonToEmail(clipboardValue, _srcField, targetField, _userPreferences, currentValue) {
    var _a;
    const emails = (_a = clipboardValue.rawValue) === null || _a === void 0 ? void 0 : _a.filter((value) => value.replace(/[ ;,`']/, "") !== "").filter((value) => (0, email_validation_1.validateEmailAddress)(value));
    if (!(emails === null || emails === void 0 ? void 0 : emails.length)) {
        return currentValue;
    }
    return targetField.params.entries_allowed === "multiple"
        ? emails
        : [emails[0]];
}
exports.clipboardJsonToEmail = clipboardJsonToEmail;
function clipboardEmailSelf(clipboardValue, _srcField, targetField, _userPreferences) {
    const emails = clipboardValue.rawValue;
    if (!(emails === null || emails === void 0 ? void 0 : emails.length)) {
        return [];
    }
    return targetField.params.entries_allowed === "multiple"
        ? emails
        : [emails[0]];
}
exports.clipboardEmailSelf = clipboardEmailSelf;
function clipboardDateToDueDate(clipboardValue, srcField, targetField, userPreferences, currentValue) {
    var _a;
    return {
        ...(0, date_range_1.emptyDateRange)(),
        to_date: ((_a = clipboardValue.rawValue) === null || _a === void 0 ? void 0 : _a.date)
            ? clipboardValue.rawValue
            : { date: null, include_time: false },
        status_updated_on: null,
        status_is_completed: false,
        repeating_task: currentValue === null || currentValue === void 0 ? void 0 : currentValue.repeating_task,
    };
}
exports.clipboardDateToDueDate = clipboardDateToDueDate;
function clipboardDependencyToSelf(clipboardValue, srcField, targetField, userPreferences, currentValue) {
    return {
        ...(0, get_value_1.getDependencyFieldEmptyValue)(),
        ...clipboardValue.rawValue,
    };
}
exports.clipboardDependencyToSelf = clipboardDependencyToSelf;
function clipboardDueDateToSelf(clipboardValue, srcField, targetField, userPreferences, currentValue) {
    return {
        ...(0, date_range_1.emptyDateRange)(),
        ...clipboardValue.rawValue,
        repeating_task: currentValue === null || currentValue === void 0 ? void 0 : currentValue.repeating_task,
    };
}
exports.clipboardDueDateToSelf = clipboardDueDateToSelf;
function clipboardDateRangeToDueDate(clipboardValue, srcField, targetField, userPreferences, currentValue) {
    var _a, _b, _c, _d, _e, _f;
    const dateRange = clipboardValue.rawValue;
    if (!!((_a = dateRange === null || dateRange === void 0 ? void 0 : dateRange.from_date) === null || _a === void 0 ? void 0 : _a.date) && !((_b = dateRange === null || dateRange === void 0 ? void 0 : dateRange.to_date) === null || _b === void 0 ? void 0 : _b.date)) {
        return {
            ...(0, date_range_1.emptyDateRange)(),
            to_date: dateRange === null || dateRange === void 0 ? void 0 : dateRange.from_date,
            status_updated_on: null,
            status_is_completed: false,
            repeating_task: currentValue === null || currentValue === void 0 ? void 0 : currentValue.repeating_task,
        };
    }
    else if (!!((_c = dateRange === null || dateRange === void 0 ? void 0 : dateRange.from_date) === null || _c === void 0 ? void 0 : _c.date) &&
        !!((_d = dateRange === null || dateRange === void 0 ? void 0 : dateRange.to_date) === null || _d === void 0 ? void 0 : _d.date) &&
        ((_e = dateRange === null || dateRange === void 0 ? void 0 : dateRange.from_date) === null || _e === void 0 ? void 0 : _e.date) > ((_f = dateRange === null || dateRange === void 0 ? void 0 : dateRange.to_date) === null || _f === void 0 ? void 0 : _f.date)) {
        return {
            from_date: dateRange === null || dateRange === void 0 ? void 0 : dateRange.to_date,
            to_date: dateRange === null || dateRange === void 0 ? void 0 : dateRange.from_date,
            status_updated_on: null,
            status_is_completed: false,
            repeating_task: currentValue === null || currentValue === void 0 ? void 0 : currentValue.repeating_task,
        };
    }
    else {
        return {
            status_updated_on: null,
            status_is_completed: false,
            repeating_task: currentValue === null || currentValue === void 0 ? void 0 : currentValue.repeating_task,
            ...dateRange,
        };
    }
}
exports.clipboardDateRangeToDueDate = clipboardDateRangeToDueDate;
function clipboardCreatedUpdatedToDueDate(clipboardValue, srcField, targetField, userPreferences, currentValue) {
    const rawValue = clipboardValue.rawValue;
    return {
        ...(0, date_range_1.emptyDateRange)(),
        to_date: (rawValue === null || rawValue === void 0 ? void 0 : rawValue.date)
            ? rawValue.date
            : { date: null, include_time: false },
        status_updated_on: null,
        status_is_completed: false,
        repeating_task: currentValue === null || currentValue === void 0 ? void 0 : currentValue.repeating_task,
    };
}
exports.clipboardCreatedUpdatedToDueDate = clipboardCreatedUpdatedToDueDate;
function clipboardTextToDueDate(clipboardValue, _srcField, targetField, userPreferences, currentValue) {
    var _a, _b;
    return {
        ...clipboardTextToDateRange(clipboardValue, _srcField, targetField, userPreferences, currentValue),
        status_updated_on: (_a = currentValue === null || currentValue === void 0 ? void 0 : currentValue.status_updated_on) !== null && _a !== void 0 ? _a : null,
        status_is_completed: (_b = currentValue === null || currentValue === void 0 ? void 0 : currentValue.status_is_completed) !== null && _b !== void 0 ? _b : false,
        repeating_task: currentValue === null || currentValue === void 0 ? void 0 : currentValue.repeating_task,
    };
}
exports.clipboardTextToDueDate = clipboardTextToDueDate;
function clipboardTextToDateRange(clipboardValue, _srcField, targetField, userPreferences, currentValue) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    const text = (_a = clipboardValue.text) !== null && _a !== void 0 ? _a : "";
    const newValueIsEmpty = !text.replace(/\n/g, " ").trim();
    if (newValueIsEmpty && !targetField.params.required) {
        return (0, date_range_1.emptyDateRange)();
    }
    const [fromDate, toDate] = text.split(/–|—|→|->|;|\||to| - /);
    let dateRange = (0, date_range_1.emptyDateRange)();
    const parsedFromDate = (0, date_1.textToDateValue)(fromDate.trim(), userPreferences);
    if (targetField.field_type === "duedatefield" && !toDate) {
        dateRange.to_date = parsedFromDate;
    }
    else {
        const parsedToDate = (0, date_1.textToDateValue)(toDate === null || toDate === void 0 ? void 0 : toDate.trim(), userPreferences);
        dateRange.from_date = parsedFromDate;
        dateRange.to_date = parsedToDate;
    }
    if (targetField.field_type !== "duedatefield") {
        if (((_b = dateRange === null || dateRange === void 0 ? void 0 : dateRange.from_date) === null || _b === void 0 ? void 0 : _b.date) && !((_c = dateRange === null || dateRange === void 0 ? void 0 : dateRange.to_date) === null || _c === void 0 ? void 0 : _c.date)) {
            dateRange.to_date = dateRange.from_date;
        }
        else if (!((_d = dateRange === null || dateRange === void 0 ? void 0 : dateRange.from_date) === null || _d === void 0 ? void 0 : _d.date) && ((_e = dateRange === null || dateRange === void 0 ? void 0 : dateRange.to_date) === null || _e === void 0 ? void 0 : _e.date)) {
            dateRange.from_date = dateRange.to_date;
        }
    }
    if (!!((_f = dateRange === null || dateRange === void 0 ? void 0 : dateRange.from_date) === null || _f === void 0 ? void 0 : _f.date) &&
        ((_g = dateRange === null || dateRange === void 0 ? void 0 : dateRange.to_date) === null || _g === void 0 ? void 0 : _g.date) &&
        ((_h = dateRange === null || dateRange === void 0 ? void 0 : dateRange.from_date) === null || _h === void 0 ? void 0 : _h.date) > ((_j = dateRange === null || dateRange === void 0 ? void 0 : dateRange.to_date) === null || _j === void 0 ? void 0 : _j.date)) {
        dateRange = {
            from_date: dateRange.to_date,
            to_date: dateRange.from_date,
        };
    }
    if ((0, isEqual_1.default)(dateRange, (0, date_range_1.emptyDateRange)())) {
        return currentValue;
    }
    return dateRange;
}
exports.clipboardTextToDateRange = clipboardTextToDateRange;
function clipboardTextToPhone(clipboardValue, _srcField, targetField, userPreferences, currentValue) {
    const newValueIsEmpty = !clipboardValue.text.trim();
    if (newValueIsEmpty && !targetField.params.required) {
        return [];
    }
    const validatedText = clipboardValue.text
        .replace(/\s+/g, "")
        .replace(/\(/g, "")
        .replace(/\)/g, "")
        .split(/[;,`']/)
        .filter((value) => value.replace(/[;,']/, "") !== "");
    const defaultCountry = targetField.params.default_country
        ? targetField.params.default_country.toUpperCase()
        : getUserDefaultCountryCode(userPreferences);
    const phones = parsePhonesFromList(validatedText.map((phone) => getParsedPhone(phone)), defaultCountry);
    if (!phones.length) {
        return currentValue;
    }
    return targetField.params.entries_allowed === "multiple"
        ? phones
        : [phones[0]];
}
exports.clipboardTextToPhone = clipboardTextToPhone;
// TODO @igorbolotnikov: This abomination must be refactored.
function getParsedPhone(text) {
    var _a;
    const phoneType = Object.values(types_1.PhoneTypes).find((type) => {
        return ((types_1.phoneTypeNames[type] &&
            text.toLowerCase().startsWith(types_1.phoneTypeNames[type].toLowerCase())) ||
            (types_1.phoneTypeTitles[type] &&
                text.toLowerCase().startsWith(types_1.phoneTypeTitles[type].toLowerCase())));
    });
    let phone = text;
    const phoneTypeEntry = Object.entries(types_1.PhoneTypes).find(([, value]) => value === phoneType);
    const typeName = (_a = phoneTypeEntry === null || phoneTypeEntry === void 0 ? void 0 : phoneTypeEntry[0]) !== null && _a !== void 0 ? _a : null;
    if (typeName) {
        phone = text.substring(typeName.length);
        return {
            phone,
            phone_type: phoneType,
        };
    }
    return {
        phone,
    };
}
function getUserDefaultCountryCode(userPreferences) {
    try {
        return userPreferences.locale.value.split("-")[1];
    }
    catch (e) {
        return types_1.DEFAULT_COUNTRY;
    }
}
function clipboardJsonToPhone(clipboardValue, _srcField, targetField, _userPreferences, currentValue) {
    var _a, _b;
    const defaultCountry = targetField.params.default_country
        ? targetField.params.default_country.toUpperCase()
        : types_1.DEFAULT_COUNTRY;
    const phones = parsePhonesFromList((_b = (_a = clipboardValue.rawValue) === null || _a === void 0 ? void 0 : _a.map((phone) => ({ phone }))) !== null && _b !== void 0 ? _b : [], defaultCountry);
    if (!phones.length) {
        return currentValue;
    }
    return targetField.params.entries_allowed === "multiple"
        ? phones
        : [phones[0]];
}
exports.clipboardJsonToPhone = clipboardJsonToPhone;
function clipboardPhoneSelf(clipboardValue, _srcField, targetField, _userPreferences) {
    const rawValue = clipboardValue.rawValue;
    return targetField.params.entries_allowed === "multiple"
        ? rawValue
        : [rawValue[0]];
}
exports.clipboardPhoneSelf = clipboardPhoneSelf;
function parsePhonesFromList(phones, defaultCountry) {
    return phones
        .filter((value) => {
        const phoneNumber = (0, libphonenumber_js_1.parsePhoneNumberFromString)(value.phone, defaultCountry);
        return !!(phoneNumber === null || phoneNumber === void 0 ? void 0 : phoneNumber.isValid());
    })
        .map((value) => ({
        ...(0, phone_1.initPhoneItem)((0, libphonenumber_js_1.parsePhoneNumberFromString)(value.phone, defaultCountry), value.phone),
        ...(value.phone_type && { phone_type: value.phone_type }),
    }))
        .filter((item) => item.phone_number);
}
function clipboardTagsToPhone(clipboardValue, srcField, targetField, _userPreferences, currentValue) {
    var _a, _b;
    const rawValue = new Set(clipboardValue.rawValue);
    const labels = ((_b = (_a = srcField.params) === null || _a === void 0 ? void 0 : _a.choices) !== null && _b !== void 0 ? _b : [])
        .filter(({ value }) => rawValue.has(String(value)))
        .map(({ label }) => label);
    const phones = stringsToPhones(labels, targetField);
    return phones.length ? phones : currentValue;
}
exports.clipboardTagsToPhone = clipboardTagsToPhone;
function stringsToPhones(stringList, targetField) {
    const defaultCountry = targetField.params.default_country
        ? targetField.params.default_country.toUpperCase()
        : types_1.DEFAULT_COUNTRY;
    const phones = parsePhonesFromList(stringList.map((phone) => ({ phone })), defaultCountry);
    return targetField.params.entries_allowed === "multiple"
        ? phones
        : phones.slice(0, 1);
}
exports.stringsToPhones = stringsToPhones;
const clipboardTextToAddress = (clipboardValue, _srcField, _targetField, _userPreferences) => {
    const processedText = clipboardValue.text.replace(/\n/g, " ").trim();
    return {
        location_address: processedText,
        location_address2: "",
        location_zip: "",
        location_country: "",
        location_state: "",
        location_city: "",
        location_longitude: "",
        location_latitude: "",
        sys_root: processedText,
    };
};
exports.clipboardTextToAddress = clipboardTextToAddress;
function clipboardLinkSelf(clipboardValue, _srcField, targetField) {
    const value = clipboardValue.rawValue;
    if (!(value === null || value === void 0 ? void 0 : value.length)) {
        return [];
    }
    return targetField.params.entries_allowed === "multiple" ? value : [value[0]];
}
exports.clipboardLinkSelf = clipboardLinkSelf;
function clipboardTextToLink(clipboardValue, srcField, targetField, userPreferences, currentValue) {
    var _a, _b;
    const linkifyItInstance = (0, link_1.linkify)();
    const { text } = clipboardValue;
    const newValueIsEmpty = !text.trim();
    if (newValueIsEmpty && !targetField.params.required) {
        return [];
    }
    if (linkifyItInstance.test(text)) {
        const urls = (_b = (_a = linkifyItInstance.match(text)) === null || _a === void 0 ? void 0 : _a.map((value) => value.url)) !== null && _b !== void 0 ? _b : [];
        return targetField.params.entries_allowed === "multiple" ? urls : [urls[0]];
    }
    else {
        return currentValue;
    }
}
exports.clipboardTextToLink = clipboardTextToLink;
const clipboardReferenceFieldToLink = (clipboardValue, srcField, targetField) => {
    var _a, _b;
    const linkifyItInstance = (0, link_1.linkify)();
    const links = (_b = (_a = clipboardValue.rawValue) === null || _a === void 0 ? void 0 : _a.filter((link) => linkifyItInstance.test(link))) !== null && _b !== void 0 ? _b : [];
    return targetField.params.entries_allowed === "multiple" ? links : [links[0]];
};
exports.clipboardReferenceFieldToLink = clipboardReferenceFieldToLink;
const pasteRulesSmartDoc = {};
Object.keys(clipboard_1.textPasteRules).forEach((field) => (pasteRulesSmartDoc[field] = clipboard_1.textToDoc));
exports.docPasteRules = {
    ...pasteRulesSmartDoc,
    recordidfield: rawToDoc,
    textfield: clipboard_1.textToDoc,
    recordtitlefield: clipboard_1.textToDoc,
    richtextareafield: selfToDoc,
};
function rawToDoc(clipboardValue, ..._rest) {
    return (0, clipboard_1.textToDocValue)(clipboardValue.rawValue);
}
exports.rawToDoc = rawToDoc;
function selfToDoc(clipboardValue, ..._rest) {
    return clipboardValue.rawValue;
}
exports.selfToDoc = selfToDoc;
function clipboardLinkedRecordFieldToSelf(clipboardValue, srcField, targetField, _userPreferences, currentValue) {
    var _a;
    if (((_a = srcField.params) === null || _a === void 0 ? void 0 : _a.linked_application) !==
        targetField.params.linked_application) {
        return currentValue;
    }
    const rawValue = clipboardValue.rawValue;
    const recordsIds = rawValue.map((record) => record.id);
    if (targetField.params.entries_allowed === "single") {
        return recordsIds.length ? [recordsIds[0]] : [];
    }
    return recordsIds;
}
exports.clipboardLinkedRecordFieldToSelf = clipboardLinkedRecordFieldToSelf;
const clipboardForTextToLinkedRecordField = (records, targetField, symmetricField) => {
    const isMultipleEntryParentField = !(0, linked_record_1.isSingleEntryAllowedInParent)(targetField, symmetricField);
    const isSingleEntryField = targetField.params.entries_allowed === "single";
    const recordsIds = records
        .filter((record) => {
        if (!symmetricField || isMultipleEntryParentField)
            return true;
        // Single entry is allowed in parent, the value must be empty;
        // If not, then this means that the field already has a link to this record
        const parentFieldValue = (0, fields_1.getValueFromRecordByField)(record, symmetricField);
        return (0, linked_record_1.isLinkedRecordValueEmpty)(parentFieldValue);
    })
        .map((record) => record.id);
    if (isSingleEntryField)
        return recordsIds.length ? [recordsIds[0]] : [];
    return recordsIds;
};
exports.clipboardForTextToLinkedRecordField = clipboardForTextToLinkedRecordField;
function clipboardCreatedUpdatedToMember(clipboardValue) {
    const rawValue = clipboardValue.rawValue;
    return [rawValue.id];
}
exports.clipboardCreatedUpdatedToMember = clipboardCreatedUpdatedToMember;
function clipboardMemberToSelf(clipboardValue, _srcField, targetField, _userPreferences, currentValue, _extra, appRecordsService) {
    var _a;
    const rawValue = clipboardValue.rawValue;
    if (!rawValue.length) {
        return [];
    }
    let filteredMembers = rawValue;
    if (appRecordsService) {
        filteredMembers = (0, assigned_to_1.filterMembersByFieldFilter)(targetField, (_a = appRecordsService.getAppStructure(types_1.MEMBERS_APP_SLUG)) !== null && _a !== void 0 ? _a : [], rawValue);
    }
    if (!filteredMembers.length) {
        return currentValue !== null && currentValue !== void 0 ? currentValue : [];
    }
    if (targetField.params.entries_allowed === "single") {
        filteredMembers = filteredMembers.slice(0, 1);
    }
    return membersToMemberFieldValue(filteredMembers);
}
exports.clipboardMemberToSelf = clipboardMemberToSelf;
function clipboardFullNameToMember(clipboardValue, _srcField, targetField, _userPreferences, currentValue, extra, appRecordsService) {
    var _a, _b, _c;
    const rawValue = clipboardValue.rawValue;
    const fullName = (_b = (_a = rawValue.sys_root) === null || _a === void 0 ? void 0 : _a.toLocaleLowerCase()) !== null && _b !== void 0 ? _b : "";
    if (!appRecordsService) {
        return [fullName];
    }
    const members = appRecordsService.getAllRecordsForApplication(types_1.MEMBERS_APP_SLUG);
    return clipboardMemberValue(targetField, fullName ? [fullName] : [], currentValue, (_c = appRecordsService.getAppStructure(types_1.MEMBERS_APP_SLUG)) !== null && _c !== void 0 ? _c : [], members);
}
exports.clipboardFullNameToMember = clipboardFullNameToMember;
function clipboardTextToMember(clipboardValue, _srcField, targetField, _userPreferences, currentValue, extra, appRecordsService) {
    var _a;
    const newValueIsEmpty = !clipboardValue.text.replace(/\n/g, " ").trim();
    if (newValueIsEmpty && !targetField.params.required) {
        return [];
    }
    const values = (0, utils_1.processClipboardTextValueWithSeparators)(clipboardValue).map((value) => value.replace(/\[|\]|'/g, "").toLocaleLowerCase());
    if (!values.length) {
        return currentValue;
    }
    if (!appRecordsService) {
        return values;
    }
    const members = appRecordsService.getAllRecordsForApplication(types_1.MEMBERS_APP_SLUG);
    return clipboardMemberValue(targetField, values, currentValue, (_a = appRecordsService.getAppStructure(types_1.MEMBERS_APP_SLUG)) !== null && _a !== void 0 ? _a : [], members);
}
exports.clipboardTextToMember = clipboardTextToMember;
function clipboardLinkedRecordToMember(clipboardValue, _srcField, targetField, _userPreferences, currentValue, extra, appRecordsService) {
    var _a;
    const rawValue = clipboardValue.rawValue;
    const values = rawValue.map((value) => {
        var _a, _b, _c;
        return ((_a = value === null || value === void 0 ? void 0 : value.sys_title) === null || _a === void 0 ? void 0 : _a.toLocaleLowerCase()) ||
            ((_c = (_b = value.full_name) === null || _b === void 0 ? void 0 : _b.sys_root) === null || _c === void 0 ? void 0 : _c.toLocaleLowerCase()) ||
            value.email[0].toLocaleLowerCase();
    });
    if (!appRecordsService) {
        return values;
    }
    const members = appRecordsService.getAllRecordsForApplication(types_1.MEMBERS_APP_SLUG);
    return clipboardMemberValue(targetField, values, currentValue, (_a = appRecordsService.getAppStructure(types_1.MEMBERS_APP_SLUG)) !== null && _a !== void 0 ? _a : [], members);
}
exports.clipboardLinkedRecordToMember = clipboardLinkedRecordToMember;
function clipboardMemberValue(targetField, filterValues, currentValue, membersAppStructure, members) {
    let filteredMembers = getFilteredMembers(targetField, filterValues, membersAppStructure, members);
    if (!filteredMembers.length) {
        return currentValue !== null && currentValue !== void 0 ? currentValue : [];
    }
    if (targetField.params.entries_allowed === "single") {
        filteredMembers = filteredMembers.slice(0, 1);
    }
    return membersToMemberFieldValue(filteredMembers);
}
function getFilteredMembers(targetField, values, memberAppStructure, members) {
    members = members.filter(member_1.memberIsVisible);
    const filteredMembers = (0, assigned_to_1.filterMembersByFieldFilter)(targetField, memberAppStructure, members);
    return values.flatMap((value) => 
    // Here we have to find each value separately as we want to preserve the order.
    filteredMembers.filter((member) => {
        var _a, _b, _c, _d, _e;
        return value === ((_b = (_a = member.full_name) === null || _a === void 0 ? void 0 : _a.sys_root) === null || _b === void 0 ? void 0 : _b.toLocaleLowerCase()) ||
            value === ((_c = member.full_name) === null || _c === void 0 ? void 0 : _c.first_name.toLocaleLowerCase()) ||
            value === ((_d = member.full_name) === null || _d === void 0 ? void 0 : _d.last_name.toLocaleLowerCase()) ||
            value === ((_e = member.email) === null || _e === void 0 ? void 0 : _e[0]) ||
            value === member.id;
    }));
}
function membersToMemberFieldValue(members) {
    return members.map(({ id }) => id);
}
function clipboardTimeToSelf(clipboardValue) {
    return clipboardValue.rawValue;
}
exports.clipboardTimeToSelf = clipboardTimeToSelf;
function clipboardTextToTime({ text }, srcField, targetField, preferences, currentValue) {
    const newValueIsEmpty = !text.replace(/\n/g, " ").trim();
    if (newValueIsEmpty && !targetField.params.required) {
        return null;
    }
    const date = (0, moment_1.default)(text, types_1.TIME_PARSE_FORMATS, true);
    return date.isValid() ? date.format("HH:mm:ss") : currentValue;
}
exports.clipboardTextToTime = clipboardTextToTime;
function clipboardTextToDuration(clipboardValue, _srcField, targetField, _userPreferences, currentValue) {
    const newValueIsEmpty = !clipboardValue.text.replace(/\n/g, " ").trim();
    if (newValueIsEmpty && !targetField.params.required) {
        return null;
    }
    if (newValueIsEmpty)
        return currentValue;
    const value = (0, duration_1.convertInputDuration)(clipboardValue.text, undefined);
    if (value === null) {
        return currentValue;
    }
    return value;
}
exports.clipboardTextToDuration = clipboardTextToDuration;
function clipboardDateToDateRange(clipboardValue, ..._rest) {
    return {
        from_date: clipboardValue.rawValue,
        to_date: clipboardValue.rawValue,
    };
}
exports.clipboardDateToDateRange = clipboardDateToDateRange;
function clipboardDateRangeToDateRange(clipboardValue, ..._rest) {
    return clipboardValue.rawValue;
}
exports.clipboardDateRangeToDateRange = clipboardDateRangeToDateRange;
function clipboardCreatedUpdatedToDateRange(clipboardValue, ..._rest) {
    var _a;
    const value = (_a = clipboardValue.rawValue) === null || _a === void 0 ? void 0 : _a.date;
    return {
        to_date: value,
        from_date: value,
    };
}
exports.clipboardCreatedUpdatedToDateRange = clipboardCreatedUpdatedToDateRange;
function clipboardDueDateToDateRange(clipboardValue, ..._rest) {
    var _a, _b;
    const value = clipboardValue.rawValue;
    if (((_a = value === null || value === void 0 ? void 0 : value.to_date) === null || _a === void 0 ? void 0 : _a.date) && !((_b = value === null || value === void 0 ? void 0 : value.from_date) === null || _b === void 0 ? void 0 : _b.date)) {
        value.from_date = value.to_date;
    }
    return value;
}
exports.clipboardDueDateToDateRange = clipboardDueDateToDateRange;
function clipboardTimeTrackingToSelf(clipboardValue) {
    var _a;
    return (_a = clipboardValue.rawValue) !== null && _a !== void 0 ? _a : (0, get_value_2.getTimeTrackingFieldEmptyValue)();
}
exports.clipboardTimeTrackingToSelf = clipboardTimeTrackingToSelf;
function clipboardTextToSocial(clipboard, _srcField, targetField, _userPreferences, currentValue) {
    var _a;
    let socialField = (0, social_network_1.getSocialNetworkTemplate)();
    const newValueIsEmpty = !clipboard.text.replace(/\n/g, " ").trim();
    if (newValueIsEmpty && !targetField.params.required) {
        return socialField;
    }
    const processedText = (0, utils_1.processClipboardTextValueWithSeparators)(clipboard, types_1.socialSeparators);
    for (const bit of processedText) {
        const socialNetworkItem = (0, social_network_1.getSocialNetworkItem)(bit, (_a = targetField.params.choices) !== null && _a !== void 0 ? _a : []);
        if (!socialNetworkItem) {
            continue;
        }
        socialField = { ...socialField, ...socialNetworkItem };
        if (targetField.params.entries_allowed === "single") {
            return socialField;
        }
    }
    if (!Object.values(socialField).some(Boolean)) {
        return currentValue;
    }
    return socialField;
}
exports.clipboardTextToSocial = clipboardTextToSocial;
function clipboardSocialToSocial({ text }, _srcField, targetField, _userPreferences, currentValue) {
    var _a;
    const { params: { nested, choices }, } = targetField;
    let socialField = (0, social_network_1.getSocialNetworkTemplate)();
    if (!text)
        return currentValue;
    for (const bit of text.split(/,|;/)) {
        const socialNetworkItem = (0, social_network_1.getSocialNetworkItem)(bit, (_a = targetField.params.choices) !== null && _a !== void 0 ? _a : []);
        if (!socialNetworkItem)
            continue;
        const fieldMissing = !(nested === null || nested === void 0 ? void 0 : nested.filter(({ label: nestedLabel }) => choices === null || choices === void 0 ? void 0 : choices.map(({ label: choiceLabel }) => choiceLabel.toLowerCase()).includes(nestedLabel.toLowerCase())).map(({ slug }) => slug).includes(Object.keys(socialNetworkItem)[0]));
        if (fieldMissing)
            continue;
        socialField = { ...socialField, ...socialNetworkItem };
        if (targetField.params.entries_allowed === "single") {
            return socialField;
        }
    }
    if (!Object.values(socialField).some(Boolean)) {
        return currentValue;
    }
    return socialField;
}
exports.clipboardSocialToSocial = clipboardSocialToSocial;
function clipboardTextToColor(clipboardValue, srcField, targetField, userPreferences, currentValue) {
    const newValueIsEmpty = !clipboardValue.text.replace(/\n/g, " ").trim();
    if (newValueIsEmpty && !targetField.params.required) {
        return [];
    }
    const values = parseFullColorValues(clipboardValue.text);
    if (!(values === null || values === void 0 ? void 0 : values.length)) {
        return currentValue;
    }
    if (targetField.params.entries_allowed === "multiple") {
        return values;
    }
    else {
        return values.length > 0 ? [values[0]] : [];
    }
}
exports.clipboardTextToColor = clipboardTextToColor;
const NAMED_COLOR_REGEX = /^(?!rgb)(.*)\((.*)\)$/; // matches named color patterns like `cobalt blue (#0047AB)`
const parseFullColorValue = (colorString) => {
    var _a;
    let color;
    if (!NAMED_COLOR_REGEX.test(colorString)) {
        color = (0, comparisons_1.parseColor)(colorString);
        return color ? { name: "", value: (0, comparisons_1.colorToHex)(color) } : null;
    }
    const [, name, value] = (_a = NAMED_COLOR_REGEX.exec(colorString)) !== null && _a !== void 0 ? _a : [];
    color = (0, comparisons_1.parseColor)(value);
    return color ? { name: name.trim(), value: (0, comparisons_1.colorToHex)(color) } : null;
};
exports.parseFullColorValue = parseFullColorValue;
const parseFullColorValues = (colorsString) => {
    if (!colorsString) {
        return [];
    }
    return colorsString
        .split(/[|;]/)
        .map((part) => (0, exports.parseFullColorValue)(part.trim()))
        .filter((c) => !!c);
};
const HTML_TAG_REGEX = /<(“[^”]*”|'[^’]*’|[^'”>])*>/g;
const LAST_PARENTHESIS_REGEX = /\(([^)]*)(?=\))\)$/g;
const CONTENT_INSIDE_P_TAG_REGEX = /<p>(.*)<\/p>/;
const COMMA_OUTSIDE_HTML_REGEX = /(,)(?![^<]*>|[^<>]*<\/)/g;
const regExp = /.*/;
const isHTML = (text) => {
    const htmlRegex = RegExp(HTML_TAG_REGEX);
    return !!htmlRegex.exec(text);
};
const removeItemStatusFromContent = (text) => text.replace(LAST_PARENTHESIS_REGEX, "");
const textToDocChecklist = (text) => {
    const content = removeItemStatusFromContent(text);
    return {
        data: {
            type: "doc",
            content: [
                { type: "paragraph", content: [{ type: "text", text: content }] },
            ],
        },
        html: `<p>${content}</p>`,
    };
};
const textToChecklistValue = (text) => {
    const fieldValue = (0, parsers_1.parseJSONToFieldValue)(text);
    if (fieldValue) {
        return fieldValue;
    }
    // split by , but not consider commas inside html tags
    let itemsList;
    let contentRegex;
    if (isHTML(text)) {
        itemsList = text
            .split(COMMA_OUTSIDE_HTML_REGEX)
            .filter((item) => item !== ",");
        contentRegex = RegExp(CONTENT_INSIDE_P_TAG_REGEX);
    }
    else {
        itemsList = text.split("),").map((item, index, array) => {
            if (index === array.length - 1) {
                return item;
            }
            return `${item})`;
        });
        contentRegex = RegExp(regExp);
    }
    const items = itemsList.map((item) => {
        const contentText = contentRegex.exec(item);
        const { completed, completed_at } = (0, utils_1.extractIsCompleted)(item);
        const content = !isHTML(item)
            ? textToDocChecklist(item)
            : {
                data: (contentText === null || contentText === void 0 ? void 0 : contentText.length) ? (0, parsers_1.parseHTMLToDoc)(contentText[0]) : {},
                html: (contentText === null || contentText === void 0 ? void 0 : contentText.length) ? contentText[0] : "",
            };
        return {
            id: (0, uuid_1.v4)(),
            content,
            completed,
            completed_at,
            assignee: "",
            due_date: "",
        };
    });
    return {
        total_items: items.length,
        completed_items: items.filter((item) => item.completed).length,
        items,
    };
};
exports.textToChecklistValue = textToChecklistValue;
function clipboardTextToChecklist(clipboardValue, ..._rest) {
    return (0, exports.textToChecklistValue)(clipboardValue.text);
}
exports.clipboardTextToChecklist = clipboardTextToChecklist;
function clipboardAnyToTag(clipboardValue, _srcField, _targetField, _userPreferences, currentValue) {
    if (Array.isArray(clipboardValue.rawValue)) {
        return clipboardValue.rawValue;
    }
    return clipboardTextToTag(clipboardValue, _srcField, _targetField, _userPreferences, currentValue);
}
exports.clipboardAnyToTag = clipboardAnyToTag;
function clipboardTextToTag(clipboardValue, _srcField, _targetField, _userPreferences, currentValue) {
    const newValueIsEmpty = !clipboardValue.text.replace(/\n/g, " ").trim();
    if (newValueIsEmpty && !_targetField.params.required) {
        return [];
    }
    const tags = clipboardValue.text
        .split(/[,;:|]/)
        .map((tag) => {
        tag = tag.trim();
        if (tag.startsWith("#")) {
            return truncateTag(tag.substring(1));
        }
        return truncateTag(tag);
    })
        .filter((tag) => !!tag);
    if (!tags.length) {
        return currentValue || [];
    }
    return tags;
}
exports.clipboardTextToTag = clipboardTextToTag;
function clipboardRecordIdToTag(clipboardValue, _srcField, _targetField, _userPreferences) {
    var _a;
    return [truncateTag(`ID: ${(_a = clipboardValue.rawValue) !== null && _a !== void 0 ? _a : ""}`)];
}
exports.clipboardRecordIdToTag = clipboardRecordIdToTag;
function clipboardTagToSelf(clipboardValue, _srcField, _targetField, _userPreferences) {
    var _a, _b;
    return (_b = (_a = clipboardValue.rawValue) === null || _a === void 0 ? void 0 : _a.map(truncateTag)) !== null && _b !== void 0 ? _b : [];
}
exports.clipboardTagToSelf = clipboardTagToSelf;
function clipboardListFieldsToTag(clipboardValue, srcField, _targetField, _userPreferences) {
    var _a, _b, _c;
    const values = Array.isArray(clipboardValue.rawValue)
        ? clipboardValue.rawValue
        : [clipboardValue.rawValue];
    return ((_c = (_b = (_a = srcField.params) === null || _a === void 0 ? void 0 : _a.choices) === null || _b === void 0 ? void 0 : _b.filter(({ value }) => values.includes(String(value))).map(({ label }) => truncateTag(label))) !== null && _c !== void 0 ? _c : []);
}
exports.clipboardListFieldsToTag = clipboardListFieldsToTag;
function clipboardReferenceToTag(clipboardValue, _srcField, _targetField, _userPreferences) {
    var _a, _b;
    return ((_b = (_a = clipboardValue.rawValue) === null || _a === void 0 ? void 0 : _a.map(record_1.getTitle).filter((title) => !!title).map(truncateTag)) !== null && _b !== void 0 ? _b : []);
}
exports.clipboardReferenceToTag = clipboardReferenceToTag;
function clipboardMembersToTag(clipboardValue, _srcField, _targetField, _userPreferences) {
    var _a, _b;
    return (_b = (_a = clipboardValue.rawValue) === null || _a === void 0 ? void 0 : _a.map(record_1.memberDisplayName).map(truncateTag)) !== null && _b !== void 0 ? _b : [];
}
exports.clipboardMembersToTag = clipboardMembersToTag;
function clipboardPhoneToTag(clipboardValue, _srcField, _targetField, _userPreferences) {
    var _a, _b;
    return ((_b = (_a = clipboardValue.rawValue) === null || _a === void 0 ? void 0 : _a.map((item) => {
        var _a;
        const internationalPhone = toInternationalPhone((_a = item.sys_root) !== null && _a !== void 0 ? _a : "");
        return truncateTag(internationalPhone);
    })) !== null && _b !== void 0 ? _b : []);
}
exports.clipboardPhoneToTag = clipboardPhoneToTag;
function clipboardIPToTag(clipboardValue, _srcField, _targetField, _userPreferences) {
    var _a, _b;
    return ((_b = (_a = clipboardValue.rawValue) === null || _a === void 0 ? void 0 : _a.map((item) => truncateTag(item.address))) !== null && _b !== void 0 ? _b : []);
}
exports.clipboardIPToTag = clipboardIPToTag;
function clipboardColorPickerToTag(clipboardValue, _srcField, _targetField, _userPreferences) {
    var _a;
    return ((_a = clipboardValue.rawValue) !== null && _a !== void 0 ? _a : []).map((color) => {
        var _a;
        return truncateTag((0, comparisons_1.colorValueToString)(color, (_a = _srcField.params) === null || _a === void 0 ? void 0 : _a.display_format));
    });
}
exports.clipboardColorPickerToTag = clipboardColorPickerToTag;
function truncateTag(tag) {
    return tag.slice(0, types_1.tagLabelMaxLength);
}
/**
 * Convert phone number to international format, prefixed with + if not already done.
 */
function toInternationalPhone(phoneNumber) {
    if (phoneNumber.startsWith("+")) {
        return phoneNumber;
    }
    return `+${phoneNumber}`;
}
const clipboardReferenceFieldToIP = (clipboardValue, srcField, targetField, _userPreferences) => {
    var _a;
    const addreses = ((_a = clipboardValue.rawValue) !== null && _a !== void 0 ? _a : [])
        .filter((address) => types_1.ipv4Ipv6Regex.test(address))
        .map((address) => ({
        country_code: "",
        address,
    }));
    return targetField.params.entries_allowed === "multiple"
        ? addreses
        : [addreses[0]];
};
exports.clipboardReferenceFieldToIP = clipboardReferenceFieldToIP;
function clipboardIpAddressSelf(clipboardValue, srcField, targetField, ..._rest) {
    const value = clipboardValue.rawValue;
    if (!(value === null || value === void 0 ? void 0 : value.length)) {
        return [];
    }
    return targetField.params.entries_allowed === "multiple" ? value : [value[0]];
}
exports.clipboardIpAddressSelf = clipboardIpAddressSelf;
const clipboardTextToIpAddress = (clipboardValue, srcField, targetField, _userPreferences, currentValue) => {
    const newValueIsEmpty = !clipboardValue.text.replace(/\n/g, " ").trim();
    if (newValueIsEmpty && !targetField.params.required) {
        return [];
    }
    const parts = clipboardValue.text
        .split(types_1.delimetersRegex)
        .filter((address) => types_1.ipv4Ipv6Regex.test(address));
    if (!parts.length) {
        return currentValue;
    }
    const result = parts.map((part) => ({ country_code: "", address: part }));
    return targetField.params.entries_allowed === "multiple"
        ? result
        : [result[0]];
};
exports.clipboardTextToIpAddress = clipboardTextToIpAddress;
const withChoiceMaxLength = (field, clipboardValueText) => {
    const choiceMaxLength = (0, fields_logic_registry_1.getFieldLogic)(field.field_type).choiceMaxLength;
    if (choiceMaxLength) {
        clipboardValueText = clipboardValueText.substring(0, choiceMaxLength);
    }
    return choiceMaxLength
        ? clipboardValueText.substring(0, choiceMaxLength)
        : clipboardValueText;
};
